<template>
  <div class="core requestForm">
    <div class="layui-layer-title" style="cursor: move;">{{ title }}</div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form
              ref="repairApproveFormRef"
              :show-form="true"
              requestUniqueId="repairRequestID"
            >
              <template slot-scope="{scope}">
                <div class="layui-form">
                  <layui-collapse ref="collapse" class>
                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">报修信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-two">
                            <div class="layui-form-item-left" style="width: 55%">
                              <div class="layui-form-item">
                                <label class="layui-form-label">报修编号：</label>
                                <label class="layui-form-label right textarea">{{ formData.REPAIR_BILL_CODE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">报修单名称：</label>
                                <label class="layui-form-label right textarea">{{ formData.REPAIR_BILL_EXT_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">报修分类：</label>
                                <label class="layui-form-label right">{{ formData.REPAIR_TYPE_EXT_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系人：</label>
                                <label class="layui-form-label right">{{ formData.TEMP_CONTACT_PSN_EXT_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系电话：</label>
                                <label class="layui-form-label right">{{ formData.TEMP_CONTACT_PSN_PHONE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">问题描述：</label>
                                <label class="layui-form-label right">{{ formData.PROBLEM_DESCRIPTION }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">门店信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-two">
                            <div class="layui-form-item-left" style="width: 55%">
                              <div class="layui-form-item">
                                <label class="layui-form-label">品牌名称：</label>
                                <label class="layui-form-label right textarea">{{ formData.BRAND_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">门店名称：</label>
                                <label class="layui-form-label right">{{ formData.STORE_NAME }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">店长名称：</label>
                                <label class="layui-form-label right">{{ formData.STORE_MANAGER }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">联系电话：</label>
                                <label class="layui-form-label right">{{ formData.STORE_MANAGER_PHONE }}</label>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">门店地址：</label>
                                <label class="layui-form-label right">{{ formData.ADDRESS }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="layui-colla-item">
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">审核记录</h2>
                        <div class="layui-colla-content layui-show">
                          <layui-table
                            v-if="repair_bill_id"
                            ref='repairApproveHistoryMainViewRef'
                            table-name='YW_REPAIR_APPROVE_HISTORY'
                            view-name='YW_REPAIR_APPROVE_HISTORY_VIEW'
                            :skin="'line'"
                            :sort="['APPROVE_DATE:DESC']"
                            :page-size="5"
                            :page-range="2"
                            height="260"
                            :page-options="[5, 10, 20, 50, 100]"
                            :defaultCondition="{'REPAIR_BILL_ID:0': repair_bill_id}"
                            @table-event-del='$refs.repairApproveHistoryMainViewRef.delRows($event.data)'
                          >
                            <div>
                              <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                              <layui-tableconfig :config='repairTableList'></layui-tableconfig>
                            </div>
                          </layui-table>
                        </div>
                      </div>
                    </div>
                  </layui-collapse>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="onCancelBtn()">关 闭</button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      requestId: 'repairApproveHistoryMainView',
      config: {form: {}},
      formData: {},
      title: '',
      repairTableList: [
        { field: 'repair_bill_ext_name', title: '报修单名称', width: 220 },
        { field: 'repair_type_ext_name', title: '报修分类', width: 180 },
        { field: 'store_name', title: '门店名称', width: 220 },
        { field: 'temp_contact_psn_ext_name', title: '联系人', width: 150 },
        { field: 'temp_contact_psn_phone', title: '联系电话', width: 200 },
        { field: 'problem_description', title: '问题描述', width: 250 },
        { field: 'approver_name', title: '审核人', width: 120},
        { field: 'approve_date', title: '审核时间', width: 180},
        { field: 'approve_status_name', title: '审核状态', width: 150},
        { field: 'approve_opinion', title: '审核意见',  width: 200},
      ],
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      repair_bill_id: ''
    }
  },

  mounted() {
    this.tableObj = this.$refs.repairApproveHistoryMainViewRef;

    if (this.tabParam) {
      this.formData = this.tabParam.editRow
      this.tableObj = this.tabParam.tableObj
      this.config.form = this.tabParam.editRow
      this.formType = this.tabParam.formType
      this.title = this.tabParam.title
      this.repair_bill_id = this.tabParam.repair_bill_id
    }
  },

  methods: {
    onCancelBtn() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
    },

  }
}
</script>




// WEBPACK FOOTER //
// src/components/repairs/repairManage/repairApproveHistoryMainView.vue